<template>
  <div>
    <!-- TABELA DE habilitacoes -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Habilitações</h3>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th>Seq</th>
                <th>Leilão</th>
                <th>Solicitação</th>
                <th>Auditório</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(habilitacao, index) in habilitacoes" :key="habilitacao">
                <td>{{ index + 1 }}</td>
                <td data-label="Leilão">
                  <div>
                    <b>Leilão:&nbsp;</b>
                    <a :href="getUrlLeilao(habilitacao.leilao_id)">{{ habilitacao.leilao_id }} - {{ habilitacao.leilao_titulo }}</a>
                  </div>
                  <div>
                    <b>Dt. Próx Praça:</b>
                    {{ getDataProximaPraca(habilitacao) }}
                  </div>
                  <div>
                    <span
                      style="text-transform: uppercase"
                      v-if="habilitacao.lotes_categorias_aviso && habilitacao.lotes_categorias_aviso.length > 0"
                      class="right badge badge-danger"
                    >
                      {{ habilitacao.lotes_categorias_aviso[0].nome }}
                    </span>
                  </div>
                  <div>
                    <b>Comitente:</b>
                    {{ habilitacao.comitente }} - {{ habilitacao.cidade_comitente }}/{{ habilitacao.estado_comitente }}
                  </div>
                </td>

                <td data-label="Solicitação">
                  <div>
                    <b>Data solicitação:&nbsp;</b>
                    {{ formatDate(habilitacao.created_at) }}
                  </div>
                  <div>
                    <b>IP:&nbsp;</b>
                    {{ habilitacao.ip }}
                  </div>
                  <div>
                    <b>Status habilitação:&nbsp;</b>

                    <span style="text-transform: uppercase" v-if="habilitacao.status == 'liberado'" class="right badge badge-success">
                      {{ habilitacao.status }}
                    </span>

                    <span style="text-transform: uppercase" v-if="habilitacao.status == 'bloqueado'" class="right badge badge-danger">
                      {{ habilitacao.status }}
                    </span>

                    <span style="text-transform: uppercase" v-if="habilitacao.status == 'aguardando'" class="right badge badge-warning">
                      {{ habilitacao.status }}
                    </span>
                  </div>

                  <div
                    class="card"
                    style="margin-top: 5px; margin-top: 5px; margin-bottom: 5px; background-color: #dc3545 !important; color: white"
                    v-if="habilitacao.motivo_bloqueio"
                  >
                    <div class="card-body p-2">
                      <i class="fa-solid fa-circle-exclamation" style="color: white"></i>
                      <b style="margin-left: 3px; font-size: 18px">Motivo bloqueio:</b>
                      <p style="margin-top: 5px; font-size: 18px; color: white">{{ habilitacao.motivo_bloqueio }}</p>
                    </div>
                  </div>
                </td>
                <td>
                  <a target="_blank" @click="checkHabilitacao(habilitacao)" type="button" class="btn btn-primary btn-sm">Entrar no auditório</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + habilitacoes.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: [],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      habilitacao_selecionado: "",
      filtro: "",
      paginas: [],
      habilitacoes: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome: "",
      estado: "",
      cidade: "",
      cidades: "",
      cpf_cnpj: "",
      endereco: "",
      email: "",
      fone: "",
      nome_contato: "",
    };
  },

  mounted() {
    this.buscarhabilitacoes();
  },

  methods: {
    getDataProximaPraca(habilitacao) {
      if (habilitacao.leilao_num_pracas >= 1 && habilitacao.leilao_1_realizado == 0) {
        return this.formatDate(habilitacao.leilao_1_data);
      } else if (habilitacao.leilao_num_pracas >= 2 && habilitacao.leilao_2_realizado == 0) {
        return this.formatDate(habilitacao.leilao_2_data);
      } else if (habilitacao.leilao_num_pracas >= 3 && habilitacao.leilao_3_realizado == 0) {
        return this.formatDate(habilitacao.leilao_3_data);
      } else if (habilitacao.leilao_num_pracas >= 4 && habilitacao.leilao_4_realizado == 0) {
        return this.formatDate(habilitacao.leilao_4_data);
      }
    },

    checkHabilitacao(habilitacao) {
      this.show_contato = false;

      this.isLoading = true;

      let data = {
        leilao_id: habilitacao.leilao_id,
      };

      //console.log("Busca");
      //console.log(data);

      axios
        .post(`/user/habilitacao/check`, data)
        .then((response) => {
          //console.log(response.data);

          this.isLoading = false;

          if (response.data.habilitado) {
            window.location.href = this.getUrlAuditorio(habilitacao.leilao_id);
          } else {
            this.showErrorMessageWithButtonAndReload("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.isLoading = false;

          if (typeof error == "object") {
            if (error.response.status == "403") {
              this.showErrorMessageWithButtonAndReload(
                "Ops...",
                "Você precisa estar logado para acessar o auditório. Clique em OK para atualizar a página."
              );
            } else {
              this.showErrorMessageWithButtonAndReload("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
              //this.showErrorMessageWithButton("Ops..", error.response.data.message);
            }
          } else {
            this.showErrorMessageWithButtonAndReloadIfConfirm("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
          }
        });
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    formatToCompare(date) {
      return moment(date);
    },

    getUrlAuditorio(leilao_id) {
      return "/user/auditorio/" + leilao_id;
    },

    getUrlLeilao(leilao_id) {
      return "/leilao/" + leilao_id + "/lotes";
    },

    getImagePath(habilitacao) {
      return process.env.MIX_VUE_APP_habilitacoes_ENDPOINT + "/" + habilitacao.path + "/" + habilitacao.arquivo;
    },

    getUrlEdit(habilitacao) {
      return "/admin/habilitacao/" + habilitacao.id;
    },

    show(habilitacao) {
      this.habilitacao_selecionado = habilitacao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarhabilitacoes();
      }
    },

    buscarhabilitacoes() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/user/habilitacoes/search`, data)
        .then((response) => {
          //console.log("Hab");
          console.log(response.data);

          this.habilitacoes = response.data.habilitacoes;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          //console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarhabilitacoes();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
